export default __webpack_public_path__ + "static/media/20230502_162439 - Keshav Mittal.532a3294.jpg";